import { memo, useCallback, useEffect } from 'react';
import { PressableIcon } from '@betty/moonlight';
import { BottomSheet } from '@betty/navigation';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { fetchQuests, selectActiveQuestsForGame } from '../state';

function QuestsInGameHeaderItem({ gameId }: { gameId: number }) {
  const dispatch = useDispatch();
  const activeQuests = useSelector((state) =>
    selectActiveQuestsForGame(state, gameId),
  );

  useEffect(() => {
    dispatch(fetchQuests());
  }, [dispatch]);

  const handleClick = useCallback(() => {
    if (activeQuests.length) {
      BottomSheet.open({
        namespace: 'quests',
        type: 'default',
        titleNS: 'quests',
        titleKey: 'activeQuest',
        data: { gameId },
      });
    }
  }, [gameId, activeQuests]);

  return activeQuests.length ? (
    <PressableIcon
      name="quest"
      onPress={handleClick}
      height={40}
      width={40}
      alignItems="center"
      justifyContent="center"
      backgroundColor="secondaryBackgroundDefault"
      borderRadius="radius-200"
    />
  ) : null;
}

export default memo(QuestsInGameHeaderItem);
